import { DEFAULT_INFERENCE_MODEL } from "../features/user/constants";
// Matches the backend, which falls back to the default engine when the user cannot use the saved model.
const getEffectiveInferenceModelId = (inferenceModels, permissions, currentModelId) => {
    const currentModel = inferenceModels?.find((model) => model.id === currentModelId);
    if (!currentModel || (currentModel.permission && !permissions?.includes(currentModel.permission))) {
        return DEFAULT_INFERENCE_MODEL;
    }
    return currentModel.id;
};
export default getEffectiveInferenceModelId;
